import { InputProps } from 'view/components/theme-settings/theme-setting-input';
import { TextInput } from '@rexlabs/text-input';

export function getNumberInput(): InputProps {
  return {
    input: TextInput,
    inputProps: { type: 'number' }
  };
}
